<template>
	<div>
		<FloatingMessage title="Waiting for sample event…">
			<template v-slot:content>
				<div class="title-cont">Trigger the event to complete the test and receive sample data.</div>
				<div class="mt-4 event-description">Event: {{ appName }} - {{ triggerEvent }}</div>
				<div class="display-flex flex-row flex-align-center mt-9">
					<div class="end-description">We'll wait for 3 minutes.</div>
					<div @click="$emit('reset-timer')" class="end-description ml-6 link">Reset timer</div>
				</div>
			</template>
			<template v-slot:bottom>
				<div @click="$emit('cancel')" class="light-hover-effect">Cancel</div>
				<div class="display-flex flex-row mt-4 font-size-md text-align-center flex-centerize">
					<div>Having problems?</div>
					<a href="#" target="_blank" class="light-hover-effect ml-4">Troubleshoot triggers</a>
				</div>
			</template>
		</FloatingMessage>
	</div>
</template>

<script>
import FloatingMessage from '../helpers/FloatingMessage';

export default {
	name: 'WaitingForNotificationTriggerFloatingMessage',
	components: {
		FloatingMessage,
	},
	props: {
		appName: { type: String },
		triggerEvent: { type: String },
	},
};
</script>
